import styled from 'styled-components';

export const TimeDropdown = styled.section`
  background: white;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
  border-radius: 1.2rem;
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 25rem;
  margin-top: 70px;
  z-index: 7;
  max-height: 48rem;
  height: 48rem;
  overflow-y: scroll;
  ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    li {
        padding: 1rem 3rem;
        font-size: 1.6rem;
        color: #141823;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        
        &:hover {
            background-color: #eef4fd;
        }
        &:active {
            color: #2276e3
        }
    }
  }
`;

export const TickIcon = styled.span`
  color: #18a160
`



